module.exports = __webpack_public_path__ + "static/coverage.0eb498eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coverage.png
// module id = 1385
// module chunks = 140525810354349